function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Space, Form, Drawer, Breadcrumb, Descriptions, Modal, DatePicker, Tag, Input, notification } from 'antd';
import { Table } from 'react-bootstrap';
import { ListUl, PencilSquare, GraphUpArrow, HourglassSplit, Eyedropper, BootstrapReboot, EyeFill, PrinterFill } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import PatientView from "../components/PatientView";
import Moment from 'react-moment';
import LaboForm from "../components/forms/LaboForm";
import LaboratorySheet from "../components/LaboratorySheet";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import SearchActivity from "../components/SearchActivity";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var RangePicker = DatePicker.RangePicker;
var Laboratoire = function Laboratoire() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentDept = _useState2[0],
    setCurrentDept = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    deptList = _useState4[0],
    setDeptList = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isDeptDataLoading = _useState6[0],
    setIsDeptDataLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    queueData = _useState8[0],
    setQueueData = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    currentQueueItem = _useState0[0],
    setCurrentQueueItem = _useState0[1];
  var _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    searchId = _useState10[0],
    setSearchId = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isPatientModalOpen = _useState12[0],
    setIsPatientModalOpen = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    dataChanged = _useState14[0],
    setDataChanged = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedItem = _useState16[0],
    setSelectedItem = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showSetResult = _useState18[0],
    setShowSetResult = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    sampleLoading = _useState20[0],
    setSampleLoading = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    sampleid = _useState22[0],
    setSampleid = _useState22[1];
  var _useState23 = useState(""),
    _useState24 = _slicedToArray(_useState23, 2),
    sampleError = _useState24[0],
    setSampleError = _useState24[1];
  var _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    selectedQueueItem = _useState26[0],
    setSelectedQueueItem = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    showPreview = _useState28[0],
    setShowPreview = _useState28[1];
  var ref = useRef();
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    contextHolder = _Modal$useModal2[1];
  var onSelectPeriodFinish = function onSelectPeriodFinish(values) {};
  var setSample = function setSample(q, e, i, sid) {
    setSampleError('');
    setSampleLoading(true);
    axios.post(Common.baseApiUrl + 'setsampleid', {
      queue_item_element_id: e.id.toString(),
      customer_id: q.customer.id.toString(),
      user_id: Common.currentUser.id,
      medical_item_id: i.id.toString(),
      queue_id: q.id.toString(),
      sample_id: sid
    }).then(function (response) {
      if (response.data.status == 200) {
        setDataChanged(true);
        notification.success({
          message: "Ok!",
          description: "Echantillon " + response.data.result.sample_id + " crée !",
          duration: 5
        });
      } else {
        setSampleError(response.data.message);
        notification.error({
          message: "Echec!",
          description: 'Une erreur est survenue . ' + response.data.message,
          duration: 3
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: 'Echec!',
        description: 'Une erreur est survenue - ' + error.toString(),
        duration: 3
      });
    })["finally"](function () {
      setSampleLoading(false);
    });
  };
  var handleSample = function handleSample(q, e, i) {
    setSelectedItem(i);
    setCurrentQueueItem(q);
    setSampleLoading(true);
    axios.get(Common.baseApiUrl + 'getnextsampleid/' + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setSampleid(response.data.sampleid);
        confirm({
          title: /*#__PURE__*/_jsxs("b", {
            children: ["PRELEVEMENT DU PATIENT N\xBA ", q.customer.idnumber]
          }),
          content: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsxs("p", {
              children: ["Confirmez-vous le prelevement de ", /*#__PURE__*/_jsx("b", {
                children: q.customer.firstname + ' ' + q.customer.lastname
              }), " ? "]
            }), /*#__PURE__*/_jsx("h1", {
              children: 'N.Echantillon : ' + response.data.sampleid
            })]
          }),
          cancelText: 'Annuler',
          confirmLoading: true,
          width: 720,
          okText: /*#__PURE__*/_jsx("b", {
            children: "CONFIRMER"
          }),
          onOk: function onOk() {
            setSample(q, e, i, response.data.sampleid);
          }
        });
      } else {
        message.error({
          content: 'Une erreur est survenue pendant le traitement ' + response.data.status,
          duration: 3
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur inconnue est survenue ' + error.toString(),
        duration: 3
      });
    })["finally"](function () {});
  };
  var handlePreview = function handlePreview(q) {
    setCurrentQueueItem(q);
    setShowPreview(true);
  };
  useEffect(function () {
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getdepartments").then(function (response) {
      if (response.data.status == 200) {
        setDeptList(response.data.departments);
        var dep;
        dep = response.data.departments.filter(function (d) {
          return d.dcode == 'LAB';
        });

        //let dep = response.data.departments.filter(d => d.dcode == 'CON');     
        var req;
        if (dep.length == 1) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString();
        }
        if (dep.length == 2) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString() + "," + dep[1].id.toString();
        }
        axios.get(req).then(function (qresponse) {
          setQueueData(qresponse.data.queueItems);
          console.log(qresponse.data.queueData);
        })["catch"](function (error) {
          message.error({
            content: error.toString(),
            delay: 4
          });
        })["finally"](function () {
          setIsDeptDataLoading(false);
        });
      }
    })["catch"](function (error) {
      message.error({
        content: error.toString(),
        delay: 4
      });
    })["finally"](function () {});
  }, [dataChanged]);
  useEffect(function () {
    setInterval(function () {
      setDataChanged(true);
    }, 30000);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsxs(Breadcrumb, {
            children: [/*#__PURE__*/_jsx(Breadcrumb.Item, {
              children: "Traitement"
            }), /*#__PURE__*/_jsx(Breadcrumb.Item, {
              children: /*#__PURE__*/_jsx("a", {
                href: "#",
                children: "Laboratoire"
              })
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 1,
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(Eyedropper, {
                  size: 35
                }), " Attente Pr\xE9levement"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 0;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx("ul", {
                            style: {
                              listStyleType: 'none'
                            },
                            children: q.queue_item_elements && q.queue_item_elements.filter(function (qe) {
                              return qe.laboratory_result_id == null;
                            }).map(function (e) {
                              return /*#__PURE__*/_jsx("li", {
                                children: /*#__PURE__*/_jsxs(Space, {
                                  direction: "horizontal",
                                  children: [/*#__PURE__*/_jsx(Tag, {
                                    color: "#f50",
                                    children: e.medical_item.label
                                  }), contextHolder, /*#__PURE__*/_jsx(Button, {
                                    type: "link",
                                    icon: /*#__PURE__*/_jsx(Eyedropper, {
                                      size: 20
                                    }),
                                    onClick: function onClick() {
                                      handleSample(q, e, e.medical_item);
                                    },
                                    size: "small",
                                    children: /*#__PURE__*/_jsx("b", {
                                      children: " PRELEVER"
                                    })
                                  })]
                                })
                              }, e.id);
                            })
                          })
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(BootstrapReboot, {
                  size: 35
                }), " Attente R\xE9sultats"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Fich Res."
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 0;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx("ul", {
                            style: {
                              listStyleType: 'none'
                            },
                            children: q.queue_item_elements && q.queue_item_elements.filter(function (qe) {
                              return qe.laboratory_result_id != null;
                            }).map(function (e) {
                              return /*#__PURE__*/_jsx("li", {
                                children: /*#__PURE__*/_jsxs(Space, {
                                  direction: "horizontal",
                                  children: [/*#__PURE__*/_jsx(Tag, {
                                    color: "#f50",
                                    children: e.medical_item.label
                                  }), /*#__PURE__*/_jsx(Button, {
                                    type: "link",
                                    icon: /*#__PURE__*/_jsx(PencilSquare, {
                                      size: 20
                                    }),
                                    onClick: function onClick() {
                                      setCurrentQueueItem(q);
                                      setSelectedQueueItem(e);
                                      setShowSetResult(true);
                                      setSelectedItem(e.medical_item);
                                    },
                                    size: "small",
                                    children: /*#__PURE__*/_jsx("b", {
                                      children: " SAISIR LE RES."
                                    })
                                  })]
                                })
                              }, e.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "link",
                            icon: /*#__PURE__*/_jsx(EyeFill, {
                              size: 20
                            }),
                            onClick: function onClick() {
                              handlePreview(q);
                            },
                            size: "small",
                            children: /*#__PURE__*/_jsx("b", {
                              children: " VOIR"
                            })
                          })
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 2), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(HourglassSplit, {
                  size: 35
                }), " Historique"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Prenom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Fich Res."
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 1;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx("ul", {
                            style: {
                              listStyleType: 'none'
                            },
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx("li", {
                                children: /*#__PURE__*/_jsxs(Space, {
                                  direction: "horizontal",
                                  children: [/*#__PURE__*/_jsx(Tag, {
                                    color: "#f50",
                                    children: e.medical_item.label
                                  }), /*#__PURE__*/_jsx(Button, {
                                    type: "link",
                                    icon: /*#__PURE__*/_jsx(PencilSquare, {
                                      size: 20
                                    }),
                                    onClick: function onClick() {
                                      setCurrentQueueItem(q);
                                      setSelectedQueueItem(e);
                                      setShowSetResult(true);
                                      setSelectedItem(e.medical_item);
                                    },
                                    size: "small",
                                    children: /*#__PURE__*/_jsx("b", {
                                      children: " SAISIR LE RES."
                                    })
                                  })]
                                })
                              }, e.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "link",
                            icon: /*#__PURE__*/_jsx(EyeFill, {
                              size: 20
                            }),
                            onClick: function onClick() {
                              handlePreview(q);
                            },
                            size: "small",
                            children: /*#__PURE__*/_jsx("b", {
                              children: " VOIR"
                            })
                          })
                        })]
                      }, q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 3), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(GraphUpArrow, {
                  size: 35
                }), " Activit\xE9s"]
              }),
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius white-bg",
                style: {
                  minHeight: '300px'
                },
                children: currentDept && /*#__PURE__*/_jsx(SearchActivity, {
                  dcode: currentDept.dcode
                })
              })
            }, 5)]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsxs("b", {
        children: ["DOSSIER PATIENT N\xBA ", searchId]
      }),
      destroyOnClose: true,
      footer: null,
      open: isPatientModalOpen,
      onCancel: function onCancel() {
        setIsPatientModalOpen(false);
      },
      children: /*#__PURE__*/_jsx(PatientView, {
        pid: searchId
      })
    }), currentQueueItem && currentQueueItem.customer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["RESULTAT LABORATOIRE DU PATIENT N\xBA ", currentQueueItem.customer.idnumber]
        }),
        destroyOnClose: true,
        footer: null,
        centered: true,
        width: "70%",
        visible: showSetResult,
        onCancel: function onCancel() {
          setShowSetResult(false);
        },
        children: selectedQueueItem && selectedQueueItem.laboratory_result_id != null && /*#__PURE__*/_jsx(LaboForm, {
          medical_item: selectedItem,
          laboratory_result_id: selectedQueueItem.laboratory_result_id,
          queue_item: currentQueueItem,
          queue_item_element: selectedQueueItem,
          customer: currentQueueItem.customer,
          handler: function handler() {
            setShowSetResult(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Opération réussie"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["FICHE DE RESULTAT DU PATIENT N\xBA ", currentQueueItem.customer.idnumber]
        }),
        destroyOnClose: true,
        footer: null,
        centered: true,
        width: "70%",
        visible: showPreview,
        onClose: function onClose() {
          setShowPreview(false);
        },
        extra: /*#__PURE__*/_jsx(Space, {
          children: /*#__PURE__*/_jsx(ReactToPrint, {
            content: function content() {
              return ref.current;
            },
            children: /*#__PURE__*/_jsx(PrintContextConsumer, {
              children: function children(_ref) {
                var handlePrint = _ref.handlePrint;
                return /*#__PURE__*/_jsx(Button, {
                  size: "large",
                  type: "primary",
                  onClick: handlePrint,
                  children: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(PrinterFill, {
                      size: 22
                    }), " IMPRIMER"]
                  })
                });
              }
            })
          })
        }),
        children: /*#__PURE__*/_jsx(LaboratorySheet, {
          ref: ref,
          queue_item: currentQueueItem
        })
      })]
    })]
  });
};
export default Laboratoire;